module.exports = __webpack_public_path__ + "static/media/Buildershape.4ec91638.svg";